import { Grid, Stack } from "@mui/material";
import type { PropsWithChildren } from "react";
import { BAR_MYPLANN_LIGHT } from "web_myplann/Utils/constants";

type Props = {
	disablePadding?: boolean;
	contentPadding?: {
		x?: number;
		y?: number;
	};
	bottomComponent?: React.ReactNode;
	disableBottomPadding?: boolean;
	bgColor?: string;
};

export const HeaderBase = ({
	children,
	disablePadding,
	bottomComponent,
	disableBottomPadding,
	contentPadding,
	bgColor,
}: PropsWithChildren<Props>) => {
	return (
		<Stack
			width="100%"
			bgcolor={
				bgColor ??
				((t) =>
					t.palette.mode === "dark"
						? t.palette.deprecated.grey[50]
						: BAR_MYPLANN_LIGHT)
			}
		>
			<Grid
				container
				display="flex"
				flexDirection="row"
				alignItems="center"
				paddingX={disablePadding ? undefined : (contentPadding?.x ?? 1.6)}
				paddingY={disablePadding ? undefined : (contentPadding?.y ?? 1.6)}
			>
				{children}
			</Grid>
			<Stack
				pb={bottomComponent && !disableBottomPadding ? 2 : 0}
				px={!disableBottomPadding ? 1.6 : 0}
			>
				{bottomComponent}
			</Stack>
		</Stack>
	);
};
